import type { InjectionKey } from 'vue';
import type { UploaderContext } from '../types';

export const uploaderKey: InjectionKey<UploaderContext> = 'uploader' as any;
